import React from 'react';
import Content from './Content';
import './App.css';

const App = () => {
    return (
        <Content/>
    );
};

export default App;